<template>

  <div class="row">
	 
    <div class="col-xl-12">
      <h4 class="title">Compliance</h4>
      <p class="category">
      Compliance Overview.
      </p>
    </div>
    
    
    
   		
          <div class="card "  @click="goToComplianceControllers()">
      	 	<div class="card-header text-center">
          		<h5 class="card-title">Register Of Registrable Controllers</h5>  
          	</div>
          	<div class="card-content text-center">
          		   <p-button type="info"  @click="goToComplianceControllers()" >
      						<i slot="label" class="fa fa-edit"></i> 
            				  View
            	  </p-button>
          	
          	</div>
          </div>
        
        
        
    
   
  
  </div>
</template>
<script>
  import Vue from 'vue'
  
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  import {Table, TableColumn, Select, Option} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import users from './users'
  
  
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  export default{
    components: {
      PPagination
    },
     
    
    data () {
      return {
      	controllers:[],
      	tableTd:'',

      
      }
    },
    mounted() {
    	  /*swal.showLoading();
     	  let uri = this.$base_url+'/api/v1/entities/get/compliance_overview';
		  ApiService.get(uri).then(response => {
		  		this.controllers = response.data.controllers;
		  		 swal.close();
		  
		  });
		  */
    },
    methods: {
     goToComplianceControllers(){
     	 this.$router.push( '/compliance-controllers/');     
     
     },
    
     goToComplianceUpdates(shareholder_id, entity_id){
      	 this.$router.push( '/compliance-updates/'+ shareholder_id +'/entity/'+ entity_id)
      },
      sendNotification(type, object_id, entity_id){
      		let compliance_type = 1;
      		
      		swal.showLoading();
      		let uri = this.$base_url+'/api/v1/entities/send_compliance_form';
			ApiService.post(uri,{
      					'object_id': object_id,
      					'type': type,
      					'entity_id': entity_id,
      					'compliance_type': compliance_type
      				}).then(response => {
      					swal.close();
      					 
						swal({
						  title: 'Done.',
						  text: 'The email notification has been sent.',
						  type: 'success',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
						}).then(function(){
								swal.close();
								
						})//end swal
			
			})



      
      },
      
    }
  }
</script>
<style lang="scss">
.el-table .sort-caret{
	border:8px solid transparent;
}

.el-table .sort-caret.ascending{
	top:-3px;
}
.el-table .sort-caret.descending{
	bottom:1px;
}


</style>
